import { useReduxLoading } from '@core/hooks';
import { ContasPagarTable } from 'app/main/contaspagar/container';
import { ContasPagarAction, useContasPagar } from 'app/main/contaspagar/store';
import contasPagarApi from 'app/services/api/contasPagarApi';
import React, { useEffect, useState } from 'react';

const PesquisaContaPagarTable = ({ extratoSelecionado }) => {
  const [loading] = useState(false);
  const [state, dispatch] = useContasPagar();

  useReduxLoading(loading);

  useEffect(() => {
    const idsSelecionados = state.selecionados.map((selecionado) => selecionado.id);
    ContasPagarAction.buscarSomatorio(dispatch, {
      ids: idsSelecionados,
      query: state.requestParams.q,
      tipoSelecao: state.tipoSelecao,
      ...state.filtroAvancadoFormatado,
    });
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.requestParams.q, state.tipoSelecao]);

  const onFetchData = (params) => {
    ContasPagarAction.carregarRegistros(dispatch, params, state.filtroAvancadoFormatado);
  };

  useEffect(() => {
    const marcarSelecionadosLista = async () => {
      const selecionados = [];
      if (
        extratoSelecionado.contaPagarList &&
        extratoSelecionado.contaPagarList.filter((despesa) => !despesa.formulario).length > 0
      ) {
        extratoSelecionado.contaPagarList
          .filter((despesa) => !despesa.formulario)
          .map(async (conta) => {
            const res = await contasPagarApi.buscarPorId(conta.id);

            const nome = res.data.fornecedor.pessoa.nome;
            const valor = res.data.valorLiquido;

            selecionados.push({
              ...res.data,
              nomeFornecedor: nome,
              valor: valor,
            });
          });

        dispatch(ContasPagarAction.setSelecionados(selecionados));
      }
    };

    marcarSelecionadosLista().catch(console.error);
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ContasPagarTable isConciliacao extratoSelecionado={extratoSelecionado} onFetchData={onFetchData} />;
};

export default PesquisaContaPagarTable;
